import { render } from "./NewContent.vue?vue&type=template&id=74a6b02a&scoped=true"
import script from "./NewContent.vue?vue&type=script&lang=js"
export * from "./NewContent.vue?vue&type=script&lang=js"

import "./NewContent.vue?vue&type=style&index=0&id=74a6b02a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a6b02a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInnerLoading,QDialog,QCard,QCardSection,QInput,QUploader,QCardActions});qInstall(script, 'directives', {ClosePopup});
